// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__1nwJb {
  display: flex;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/pageFooter/logoBlock/socialBlock/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  gap: 8px;\n  //margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__1nwJb`
};
export default ___CSS_LOADER_EXPORT___;
